import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../constants/dataAids';
import { updateMarketing } from '../actions/BookingForm';
import { trackMetric } from '../utils/trackMetric';
import { BOOKING_FORM_MARKETING_CONSENT_CHECKBOX_CLICK } from '../constants/metrics';

const styles = {
  label: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: 'xsmall',
    marginLeft: 'xxsmall',
    marginBottom: 'medium'
  },
  text: {
    fontColor: 'highContrast',
    marginLeft: 'xsmall',
    marginBottom: '0'
  }
};

export default class MarketingConsent extends Component {
  onCheckboxClick = e => {
    updateMarketing(e.target.checked);
    trackMetric(BOOKING_FORM_MARKETING_CONSENT_CHECKBOX_CLICK);
  };

  render() {
    const { staticContent, marketing } = this.props;
    const {
      Block,
      Text,
      Input: { Checkbox }
    } = UX2.Element;

    return (
      <Block tag='label' style={ styles.label }>
        <Block>
          <Checkbox
            tag='input'
            type='checkbox'
            data-aid={ dataAids.BOOKING_FORM_MARKETING_CHECKBOX }
            checked={ marketing }
            onChange={ this.onCheckboxClick }
          />
        </Block>
        <Block data-aid={ dataAids.BOOKING_FORM_MARKETING_TEXT }>
          <Text style={ styles.text }>{ staticContent.marketingConsentInfo }</Text>
        </Block>
      </Block>
    );
  }
}

MarketingConsent.propTypes = {
  marketing: PropTypes.bool,
  staticContent: PropTypes.object.isRequired,
  requiresConsent: PropTypes.bool.isRequired
};
